import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { HomePage } from "@/pages/HomePage";
import { Page2 } from "@/pages/Page2";
import { Page3 } from "@/pages/Page3";

// Build da /3 isolado (PUBLIC_URL=/3 REACT_APP_HOME=page3): sobe em build/3/ sem tocar na home no ar.
const Home = process.env.REACT_APP_HOME === "page3" ? Page3 : HomePage;

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/2" element={<Page2 />} />
        <Route path="/3" element={<Page3 />} />
      </Routes>
    </Router>
  );
}

export default App;
